module.exports = __webpack_public_path__ + "assets/img/LeopardLogo.799c1f27.png";